import React, { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import compose from 'recompose/compose';
import Collapse from '@material-ui/core/Collapse';

import { IconButton, useMediaQuery, makeStyles, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { MenuItemLink, useTranslate } from 'react-admin';
import { useHistory, withRouter } from 'react-router-dom';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { getZ3PConfigValue, userIsZippityEmployee } from './helper';
import MenuBarIcon from './MenuBarIcon';
import BetaLabel from './components/BetaLabel';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
const useStyles = (theme) => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    minHeight: '100%',
    backgroundColor: "#212b36",
    color: theme.sidebar.color,
    overflow: 'auto',
    marginBottom: '40px',
  },
  menuHeader: {
    color: "#ffffff",
    display: 'flex',
    width: '100%',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    fontWeight: '500',
    paddingRight: '3px',
  },
  baseIcons: {
    color: theme.sidebar.header.color,
  },
  menuCollapse: {
    color: theme.sidebar.header.color,
    border: 'none',
  },
  menuItem: {
    color: '#C4C7C5',
    backgroundColor: theme.sidebar.header.subMenu,
    fontWeight: 'lighter',
    marginLeft: '0%',
    paddingLeft: '30px',
    fontSize: '14px',
    borderLeft: '3px solid rgba(255, 255, 255, 0)',
  },
  subMenuIcon: {
    color: theme.sidebar.color,
    fontSize: 'medium',
    height:4,
    width:4
  },
  activeMenuItem: {
    color: "#6DD58C",
    fontWeight: 'normal',
    marginLeft: '0%',
    borderLeft: `5px ${theme.sidebar.color} solid`,
    backgroundColor: theme.sidebar.header.background,
    opacity: 1,
  },
  activeSubMenuItem: {
    color: theme.sidebar.color,
    fontWeight: 'lighter',
    marginLeft: '0%',
    paddingLeft: '30px',
    fontSize: '14px',
    borderLeft: `5px ${theme.sidebar.color} solid`,
    backgroundColor: theme.sidebar.header.background
  },
  logout: {
    color: theme.sidebar.color,
  },
  menuButton: {
    marginRight: '0.5em',
    marginLeft: '-0.5em',
  },
  expandIcon: {
    marginLeft: 'auto',
  },
  title: {
    padding: '10px 16px',
    color: '#919EAB',
    fontSize: 14
  }
});

const componentStyle = makeStyles(() => ({
  betaLabel: {
    marginLeft: 'auto',
    marginRight: '15px',
  },
  menuExpanded: {
    minHeight: 'auto !important',
  },
}));

// TODO: Menus added to this array will only show up for Zippity Employees
const ZippityPrivateMenus = [];
//   {
//     menuName: 'Zippity Internal',
//     menuIcon: 'SettingsIcon',
//     resources: [
//       {
//         resource: 'integrations',
//         icon: '',
//       },
//       {
//         resource: 'coupon',
//         icon: '',
//       },
//       {
//         resource: 'pro-signup',
//         icon: '',
//       },
//     ],
//   },
// ];

const Menu = (props) => {
  const { logout, selectedMenuItem, setSelectedMenuItem } = props;
  const history = useHistory();
  const translate = useTranslate();
  const [selectedMenuHeader, setSelectedMenuHeader] = useState(null);
  const styles = useStyles(useTheme());
  const compClasses = componentStyle();
  const [menus, setMenus] = useState([]);
  const [hasTrimmedMenus, setHasTrimmedMenus] = useState(false);
  const [isUsingServiceReport, setIsUsingServiceReport] = useState(null);

  useEffect(() => {
    let sideBarMenus = getZ3PConfigValue('menus');
    if (sideBarMenus) {
      sideBarMenus = JSON.parse(JSON.stringify(sideBarMenus));
    } else {
      sideBarMenus = [];
    }

    const couponMenu = {
      menuName: 'Coupons',
      menuIcon: 'LocalOfferIcon',
      resources: [{ resource: 'coupon', icon: '' }],
    };

    let injectedCoupon = false;
    for (let i = 0; i < sideBarMenus.length; i++) {
        const m = sideBarMenus[i];
        if (
            m.menuName &&
            (m.menuName.toLowerCase().includes('service categor') ||
             m.menuName.toLowerCase().includes('service catalog'))
        ) {
            sideBarMenus.splice(i + 1, 0, couponMenu);
            injectedCoupon = true;
            break;
        }
        
        if (m.resources) {
            const resIdx = m.resources.findIndex(
               (r) => r.resource.includes('service-categor') || r.resource === 'service-offering'
            );
            if (resIdx !== -1) {
                if (m.resources.length === 1) {
                    sideBarMenus.splice(i + 1, 0, couponMenu);
                } else {
                    m.resources.splice(resIdx + 1, 0, { resource: 'coupon', icon: '' });
                }
                injectedCoupon = true;
                break;
            }
        }
    }

    if (!injectedCoupon) {
        sideBarMenus.push(couponMenu);
    }

    const isUsingServiceReportConfig = getZ3PConfigValue(
      'is_using_service_report',
    );
    if (userIsZippityEmployee()) {
      sideBarMenus = [...sideBarMenus, ...ZippityPrivateMenus];
    }
    setMenus(sideBarMenus);
    setIsUsingServiceReport(isUsingServiceReportConfig);
  }, []);

  // Remove service report from menus if pro is not using service reports
  useEffect(() => {
    if (menus && isUsingServiceReport === false && !hasTrimmedMenus) {
      let hasMenuChanged = false;
      const updatedMenus = menus.map((m) => {
        const resources = [];
        m.resources.forEach((r) => {
          if (r.resource !== 'health-check') {
            resources.push(r);
          } else if (r.resource === 'health-check') {
            hasMenuChanged = true;
          }
        });
        const updatedMenu = {
          ...m,
          resources,
        };
        return updatedMenu;
      });
      if (hasMenuChanged) {
        setMenus(updatedMenus);
        setHasTrimmedMenus(true);
      }
    }
  }, [menus, isUsingServiceReport, hasTrimmedMenus]);

  const setCurrentResourceAndMenu = (menuName = null) => {
    // This will give us the resource name (will always be second in the array, after #)
    let currentPath = window.location.hash.split('/')[1]; // eslint-disable-line no-undef
    // Remove query search params
    if (currentPath.includes('?')) {
      currentPath = currentPath.split('?')[0];
    }
    if (currentPath === '' && selectedMenuItem !== 'Dispatch') {
      return setSelectedMenuItem('Dispatch');
    }
    const currentMenu = menus?.find((menu) =>
      menu.resources.some((r) => r.resource === currentPath),
    );
    const currentResource = currentMenu?.resources.find(
      (r) => r.resource === currentPath,
    );
    if (
      currentResource &&
      !selectedMenuItem &&
      (!menuName || currentMenu?.menuName === menuName)
    ) {
      if (currentMenu.resources.length > 1) {
        setSelectedMenuHeader(currentMenu.menuName);
        setSelectedMenuItem(currentResource.resource);
      } else {
        setSelectedMenuItem(currentMenu.menuName);
      }
    }
  };

  useEffect(setCurrentResourceAndMenu, [menus, selectedMenuItem]);

  const setActiveMenu = (menuName, isHeader = false, isSubMenuItem = false) => {
    if (isHeader) {
      const currentMenu = menus.find((menu) => menu.menuName === menuName);
      const isSubMenuSelected = currentMenu.resources.some(
        (r) => r.resource === selectedMenuItem,
      );
      if (selectedMenuHeader === menuName || isSubMenuSelected) {
        setSelectedMenuHeader(null);
        if (isSubMenuSelected) {
          setSelectedMenuItem(null);
        }
      } else {
        setSelectedMenuHeader(menuName);
      }
    } else {
      setSelectedMenuItem(menuName);
      if (!isSubMenuItem) {
        setSelectedMenuHeader(null);
      }
    }
  };

  const getTitle = (resource) =>
    translate(`resources.${resource}.name`, {
      smart_count: 2,
    });

  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const open = useSelector((state) => state.admin.ui.sidebarOpen);

  const unreadBoolean = useSelector(
    (state) => state.unreadMessage.unreadBoolean,
  );

  const isMenuExpanded = (alwaysOpen, menuName, resources) => {
    return (
      alwaysOpen ||
      selectedMenuHeader === menuName ||
      resources.some((r) => r.resource === selectedMenuItem)
    );
  };

  const menuHeaderContent = (alwaysOpen, menuName, resources) => {
    return isMenuExpanded(alwaysOpen, menuName, resources) ? (
      <>
        {menuName}
        <ExpandLessIcon style={styles.expandIcon} />
      </>
    ) : (
      <>
        {menuName}
        <ExpandMoreIcon style={styles.expandIcon} />
      </>
    );
  };

  return (
    <div style={styles.main}>
      {/* Common Title */}
      <Typography variant="h6" component="div" style={styles.title}>
          Overview
      </Typography>
      {isXSmall && (
        <MenuItemLink
          to="#"
          style={styles.menuButton}
          leftIcon={
            <IconButton>
              <MenuBarIcon name="MenuIcon" style={styles.logout} />
            </IconButton>
          }
          sidebarIsOpen
          {...props}
        />
      )}

      {menus &&
        menus.map(({ menuName, menuIcon, alwaysOpen, resources }) => {
          if (resources.length > 1) {
            return (
              <Collapse
                key={menuName}
                in={isMenuExpanded(alwaysOpen, menuName, resources)}
                collapsedHeight="48px"
                classes={{
                  entered: compClasses.menuExpanded,
                }}
                data-tour-id={`menu_${menuName
                  .replace(' ', '_')
                  .toLowerCase()}`}
              >
                <MenuItemLink
                  style={styles.menuHeader}
                  onClick={() => setActiveMenu(menuName, true)}
                  key={menuName}
                  to="#"
                  className="customMenu"
                  primaryText={menuHeaderContent(
                    alwaysOpen,
                    menuName,
                    resources,
                  )}
                  leftIcon={
                    <MenuBarIcon
                      name={menuIcon}
                      style={styles.menuHeader}
                      large
                    />
                  }
                  sidebarIsOpen={open}
                />

                {resources.map(({ resource, icon, customPath }) => (
                  <MenuItemLink className="submenu_item"
                    style={
                      selectedMenuItem === resource
                        ? styles.activeSubMenuItem
                        : styles.menuItem
                    }
                    key={resource}
                    to={customPath || `/${resource}`}
                    primaryText={getTitle(resource)}
                    leftIcon={

                      <FiberManualRecordIcon style={styles.subMenuIcon} fontSize="inherit" />
                    }
                    onClick={() => setActiveMenu(resource, false, true)}
                    sidebarIsOpen={open}
                    data-tour-id={`menu_${resource
                      .replace(' ', '_')
                      .toLowerCase()}`}
                  />
                ))}
              </Collapse>
            );
          }
          return (
            <MenuItemLink
              style={
                selectedMenuItem === menuName
                  ? styles.activeMenuItem
                  : styles.menuHeader
              }
              disabled={
                history.location.pathname === `/${resources[0].resource}`
              }
              data-tour-id={`menu_${resources[0].resource
                .replace(' ', '_')
                .toLowerCase()}`}
              key={menuName}
              to={resources[0].customPath || `/${resources[0].resource}`}
              className="customMenu"
              primaryText={
                menuName === 'Quote Manager' ? (
                  <>
                    {menuName} <BetaLabel classAttr={compClasses.betaLabel} />
                  </>
                ) : (
                  menuName
                )
              }
              onClick={() => setActiveMenu(menuName, false, false)}
              leftIcon={
                ['messages', 'zipchat'].includes(menuName.toLowerCase()) ? (
                  <MenuBarIcon
                    name={menuIcon}
                    showMessageBadge={unreadBoolean}
                    style={styles.menuHeader}
                    large
                  />
                ) : (
                  <MenuBarIcon
                    name={menuIcon}
                    style={styles.menuHeader}
                    large
                  />
                )
              }
              sidebarIsOpen={open}
            />
          );
        })}
      {isXSmall && (
        <span className="menuLogout" style={styles.logout}>
          {logout}
        </span>
      )}
    </div>
  );
};

const enhance = compose(
  withRouter,
  connect(
    (state) => ({
      theme: state.theme,
    }),
    {},
  ),
);

export default enhance(Menu);
